import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WebPage from './components/WebPage';
import Services from './components/Services';
import Contact from './components/Contact';
import ImageGallery from './components/ImageGallery';
import ListProperty from './components/ListProperty';



import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
        <Route path="/buy" element={<ListProperty />} />      
          <Route path="/gallery" element={<ImageGallery />} />      
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<Services />} />
          <Route path="/" element={<WebPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
